module.exports = __webpack_public_path__ + "img/bus-tips-img.80352684.png";